import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { resolveProps } from '../utils/index.js';
function diffObjects(objA = {}, objB = {}) {
    const obj = {};
    return Object.keys(objB).reduce((diff, key) => {
        if (objB[key] !== objA[key]) {
            diff[key] = objB[key];
        }
        return diff;
    }, obj);
}
function getUniqueProperties(objA = {}, objB = {}) {
    const diff = {};
    for (const key in objB) {
        if (!(key in objA)) {
            diff[key] = objB[key];
        }
    }
    return diff;
}
class PropsProcessor {
    constructor(node, root) {
        this.lastProps = {};
        this.node = node;
        this.root = root;
        this.defaultProps = node.getDefaultProps();
        const propTypes = node.getPropTypes();
        this.events = Object.keys(propTypes).filter(p => propTypes[p] === eventListener);
    }
    removeProperties(props, properties = []) {
        const copy = { ...props };
        properties.forEach((property) => {
            delete copy[property];
        });
        return copy;
    }
    processMetaProps(rawMetaProps, breakpoint, locale) {
        return resolveProps(rawMetaProps, breakpoint, locale);
    }
    processProps(metaProps, ssotProps, props) {
        const changedProps = diffObjects(this.lastProps, props);
        const relevantProps = getUniqueProperties(metaProps, changedProps);
        this.lastProps = props;
        return { ...ssotProps, ...relevantProps };
    }
    collect(props, breakpoint, locale) {
        const ssot = this.node.getSSOT();
        const metadata = this.node.getNodeMetadata();
        const metaProps = this.processMetaProps(metadata.props, breakpoint, locale);
        const ssotProps = this.processProps(metaProps, ssot.props, props);
        ssot.setMetaProps(metaProps);
        ssot.setProps(ssotProps);
        return { ...ssot.metaProps, ...ssot.props };
    }
}
export { PropsProcessor, };
//# sourceMappingURL=props-processor.js.map